import React from 'react';
import styles from '../Toolbar.module.scss';

export const MobileFilterTitles = ({ setDrawerShown, setSortShown }) => {
  return (
    <div className={styles.mobileToolbarTitilesWrapper}>
      <span
        onClick={(event) => {
          event.stopPropagation()
          setDrawerShown(true);
        }}
        className={styles.mobileToolbarTitle}
      >
        Filters
      </span>
      <span className={styles.bar}></span>
      <span
        onClick={() => {
          setSortShown((val) => !val);
        }}
        className={styles.mobileToolbarTitle}
      >
        Sort
      </span>
    </div>
  );
};
